import * as React from "react";

const InvoiceIcon: React.FC = () => {
    return (
        <svg width="12px" height="16px" viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg">
            <g fill="#0071ad" fillRule="nonzero" stroke="none" strokeWidth={1}>
                <path
                    d="M11.685 3.647L8.353.315A1.07 1.07 0 007.59 0H1.077C.483 0 0 .483 0 1.077v13.6c0 .594.483 1.077 1.077 1.077h9.846c.594 0 1.077-.483 1.077-1.077V4.409a1.07 1.07 0 00-.315-.762zm-1.26.045H8.461a.154.154 0 01-.154-.154V1.576l2.116 2.116zm.498 11.139H1.077a.154.154 0 01-.154-.154v-13.6c0-.085.07-.154.154-.154h6.308v2.615c0 .594.483 1.077 1.077 1.077h2.615v10.062a.154.154 0 01-.154.154z"
                    transform="translate(-315 -651) translate(298 644) translate(17 5) translate(0 2)"
                />
                <path
                    d="M6.495 7.046h2.941a.462.462 0 000-.923h-2.94a.462.462 0 000 .923zM6.495 10.123h2.941a.462.462 0 000-.923h-2.94a.462.462 0 000 .923zM9.45 12.277H6.494a.462.462 0 000 .923H9.45a.462.462 0 000-.923zM4.192 5.328L3.128 6.392l-.25-.25a.462.462 0 10-.654.652l.578.577a.46.46 0 00.652 0l1.391-1.39a.462.462 0 00-.653-.653zM4.192 8.64L3.128 9.704l-.25-.25a.462.462 0 00-.654.652l.578.577a.46.46 0 00.652 0l1.391-1.39a.462.462 0 10-.653-.653zM4.192 11.717L3.128 12.78l-.25-.25a.462.462 0 00-.654.652l.578.577a.46.46 0 00.652 0l1.391-1.39a.462.462 0 10-.653-.653z"
                    transform="translate(-315 -651) translate(298 644) translate(17 5) translate(0 2)"
                />
            </g>
        </svg>
    );
};

export default React.memo(InvoiceIcon);
